app.factory("AgentSearchModel",
	function() {
		this.searchResults = {};

		return this;
	}
);